import React, { ReactElement, ReactNode } from 'react';

import { TooltipStateful } from '../../../../../../shared/components';
import SvgImage from '../../../../../../shared/components/svg-image';
import { ImageName } from '../../../../../../shared/components/svg-image/images';
import styles from './styles.css';

interface StatusIconProps {
    showTooltip: boolean;
    tooltipContent: ReactNode;
    imageName?: ImageName;
    icon?: ReactNode;
    className?: string;
    onShowTooltip?: () => void;
}

type StatusIconWrapProps = Pick<StatusIconProps, 'showTooltip' | 'tooltipContent' | 'onShowTooltip'> & {
    children: ReactElement;
};

const StatusIconWrap: React.FC<StatusIconWrapProps> = ({ children, showTooltip, tooltipContent, onShowTooltip }) =>
    showTooltip ? (
        <TooltipStateful content={tooltipContent} trigger="hover" placement="right" offset={5} onShow={onShowTooltip}>
            {children}
        </TooltipStateful>
    ) : (
        <>{children}</>
    );

export const StatusIcon: React.FC<StatusIconProps> = ({
    showTooltip,
    tooltipContent,
    imageName,
    icon,
    className,
    onShowTooltip,
}) => {
    return (
        <StatusIconWrap showTooltip={showTooltip} tooltipContent={tooltipContent} onShowTooltip={onShowTooltip}>
            <div className={className}>
                <div className={styles.status}>
                    {imageName && <SvgImage imageName={imageName} />}
                    {icon}
                </div>
            </div>
        </StatusIconWrap>
    );
};
